import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import TitanEapCrossFlowQuery, {
	TitanEapCrossFlowQuery as TitanEapCrossFlowQueryType,
} from './__generated__/TitanEapCrossFlowQuery.graphql';

export const titanEapCrossFlowQueryResource: RouteResource<
	PreloadedQuery<TitanEapCrossFlowQueryType, Record<string, unknown>>
> = createRelayResource<TitanEapCrossFlowQueryType>({
	getQuery: () => ({
		query: TitanEapCrossFlowQuery,
	}),
});
